<template>
  <layout title="Account Settings">
    <div class="flex justify-center">
      <div class="md:p-8 p-4 max-w-7xl w-full flex items-start">
        <sideMenu page="Account Settings" />
        <div class="flex-1 md:ml-8 ml-4">
          <div class="sm:flex justify-between w-full bt-delete-user">
            <div
              class="font-black text-3xl text-gray-800 inline-block lg:col-span-2 col-span-1"
            >
              Account Settings
            </div>

            <button
              type="submit"
              class="btn-danger sm:mt-0 mt-2"
              @click="toogleShowDeleteModal"
            >
              <TrashIcon class="text-white mr-2" />
              Delete Account
            </button>
          </div>

          <div class="sm:flex items-start sm:space-x-6">
            <div
              class="mt-6 bg-white shadow-allArround rounded-xl px-4 relative xl:w-1/4 min-w-max text-gray-600 font-bold"
              style="max-width: 15rem"
            >
              <div v-for="(menu, index) in subMenus" :key="index">
                <div
                  class="flex items-center cursor-pointer"
                  :class="
                    menu.id == activeMenu
                      ? 'text-primary-color'
                      : 'hover:text-gray-800'
                  "
                  @click="changeActiveMenu(menu.id)"
                >
                  <font-awesome-icon :icon="menu.icon" class="mr-2" />
                  <p class="my-3">{{ menu.name }}</p>
                  <font-awesome-icon icon="angle-right" class="ml-2" />
                </div>
                <div
                  class="w-full h-0.5 bg-gray-200 absolute left-0"
                  v-if="index < subMenus.length - 1"
                ></div>
              </div>
            </div>
            <div class="flex-1 max-w-md">
              <div
                class="mt-6 bg-white shadow-allArround rounded-xl relative"
                v-if="activeMenu == 1"
              >
                <PuSkeleton
                  class="h-full w-full z-20 rounded-xl absolute"
                  v-if="showLoading"
                />
                <div class="p-4 bg-gray-200 font-bold text-xl rounded-t-xl">
                  User Information
                </div>
                <div class="p-4 text-gray-800 overflow-hidden bg-gray-50">
                  <div>
                    <label
                      for="user_name"
                      class="block text-sm font-medium leading-5 text-gray-700 required"
                    >
                      Name
                    </label>
                    <div class="mt-1 rounded-md shadow-sm">
                      <input
                        id="user_name"
                        type="text"
                        name="user_name"
                        v-model="formUserInfo.user_name"
                        required
                        class="w-full"
                        placeholder="First and Last name"
                        maxlength="100"
                      />
                    </div>

                    <div class="error" v-if="errors.user_name">
                      {{ errors.user_name }}
                    </div>
                  </div>

                  <div class="mt-6">
                    <label
                      for="email"
                      class="block text-sm font-medium leading-5 text-gray-700 required"
                    >
                      Email
                    </label>
                    <div class="mt-1 rounded-md shadow-sm">
                      <input
                        id="email"
                        type="email"
                        name="email"
                        v-model="formUserInfo.email"
                        @input="clearEmailError"
                        @blur="validateEmailField"
                        required
                        class="w-full"
                        placeholder="example@mail.com"
                        maxlength="190"
                      />
                    </div>

                    <div class="error" v-if="frontendErrors.email">
                      {{ frontendErrors.email }}
                    </div>
                    <div class="error" v-else-if="errors.email">
                      {{ errors.email }}
                    </div>
                  </div>

                  <button class="btn-primary mt-6" @click="updateUserInfo">
                    Save Changes
                  </button>
                </div>
              </div>
              <div
                class="mt-6 bg-white shadow-allArround rounded-xl relative"
                v-if="activeMenu == 2"
              >
                <PuSkeleton
                  class="h-full w-full z-20 rounded-xl absolute"
                  v-if="showLoading"
                />
                <div class="p-4 bg-gray-200 font-bold text-xl rounded-t-xl">
                  Security Settings
                </div>
                <div class="p-4 text-gray-800 bg-gray-50">
                  <form
                    role="form"
                    @submit.prevent="updateSecurity"
                    method="POST"
                  >
                    <div>
                      <label
                        for="current_password"
                        class="block text-sm font-medium leading-5 text-gray-700 required"
                      >
                        Current Password
                      </label>
                      <div class="mt-1 rounded-md shadow-sm">
                        <input
                          id="current_password"
                          type="password"
                          name="current_password"
                          v-model="formSecurity.current_password"
                          required
                          class="w-full"
                          placeholder="Current Password"
                          maxlength="64"
                        />
                      </div>

                      <div class="error" v-if="errors.current_password">
                        {{ errors.current_password }}
                      </div>
                    </div>

                    <div class="mt-6">
                      <label
                        for="password"
                        class="block text-sm font-medium leading-5 text-gray-700 required"
                      >
                        New Password
                      </label>
                      <div class="mt-1 rounded-md shadow-sm relative">
                        <input
                          id="password"
                          type="password"
                          name="password"
                          v-model="formSecurity.password"
                          required
                          class="w-full"
                          placeholder="New Password"
                          maxlength="64"
                        />
                        <passwordReq
                          inputId="password"
                          @validPass="validPassCheck"
                        />
                      </div>
                      <password-meter :password="formSecurity.password" />
                      <div class="error" v-if="errors.password">
                        {{ errors.password }}
                      </div>
                      <div class="error" v-if="showError">
                        {{ validPass.message }}
                      </div>
                    </div>

                    <div class="mt-4">
                      <label
                        for="password_confirmation"
                        class="block text-sm font-medium leading-5 text-gray-700 required"
                      >
                        Confirm New Password
                      </label>
                      <div class="mt-1 rounded-md shadow-sm">
                        <input
                          id="password_confirmation"
                          type="password"
                          name="password_confirmation"
                          v-model="formSecurity.password_confirmation"
                          required
                          class="w-full"
                          placeholder="Confirm New Password"
                          maxlength="64"
                        />
                      </div>

                      <div class="error" v-if="errors.password_confirmation">
                        {{ errors.password_confirmation }}
                      </div>
                    </div>

                    <button type="submit" class="btn-primary mt-6">
                      Save Changes
                    </button>
                  </form>
                </div>
              </div>
              <div
                class="mt-6 bg-gray-50 shadow-allArround rounded-xl flex-1 relative"
                v-if="activeMenu == 3"
              >
                <PuSkeleton
                  class="h-full w-full z-20 rounded-xl absolute"
                  v-if="showLoading"
                />
                <div class="p-4 bg-gray-200 font-bold text-xl rounded-t-xl">
                  Billing Address
                </div>
                <div class="p-4 text-gray-800 overflow-hidden bg-gray-50">
                  <billingAddress
                    :errors="errors"
                    @toggleShowLoading="toggleShowLoading"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <modal
        ref="modal"
        :title="'Do you want to delete account?'"
        type="danger"
        subtitle="The user will no longer be able to use any services."
        buttonTitle="Delete Account"
        :show="showDeleteModal"
        icon="exclamation-triangle"
        @closeModal="toogleShowDeleteModal"
        @actionClick="deleteAccount"
      >
        <template>
          <form
            @submit.prevent="deleteAccount"
            class="flex w-full items-center mt-5 flex-col"
          >
            <div class="text-left">
              <input
                id="user_password"
                type="password"
                name="user_password"
                v-model="form.user_password"
                required
                class="w-60"
                placeholder="Enter your password"
              />
              <div class="error" v-if="errors.user_password">
                {{ errors.user_password }}
              </div>
            </div>
          </form>
        </template>
      </modal>
    </div>
  </layout>
</template>

<script>
import passwordMeter from "vue-simple-password-meter";
import { TrashIcon } from "@vue-hero-icons/outline";

const layout = () =>
  import(/* webpackChunkName: "layout" */ "../../Components/Layout/layout.vue");
const sideMenu = () =>
  import(
    /* webpackChunkName: "sideMenu" */ "../../Components/Layout/User/sideMenu.vue"
  );
const billingAddress = () =>
  import(/* webpackChunkName: "billingAddress" */ "./BillingAddress.vue");

const modal = () =>
  import(
    /* webpackChunkName: "sideMenu" */ "../../Components/modalConfirmMessage.vue"
  );

const passwordReq = () =>
  import(
    /* webpackChunkName: "passwordReq" */ "../../Components/passwordReq.vue"
  );
export default {
  components: {
    layout,
    sideMenu,
    billingAddress,
    modal,
    TrashIcon,
    passwordReq,
    passwordMeter,
  },
  props: {
    errors: Object,
  },
  data() {
    return {
      formUserInfo: {
        user_name: null,
        email: null,
      },
      formSecurity: {
        current_password: null,
        password: null,
        password_confirmation: null,
      },
      form: {
        user_password: "",
      },
      subMenus: [
        {
          id: 1,
          icon: "user",
          name: "User Information",
        },
        {
          id: 2,
          icon: "lock",
          name: "Security",
        },
        {
          id: 3,
          icon: "home",
          name: "Billing Address",
        },
      ],
      activeMenu: 1,
      showLoading: false,
      showDeleteModal: false,
      validPass: {
        value: false,
        message: "",
      },
      showError: false,
      frontendErrors: {
        email: "",
      },
    };
  },
  methods: {
    clearEmailError() {
      this.frontendErrors.email = "";
    },
    validateEmailField() {
      const email = this.formUserInfo.email || "";

      this.frontendErrors.email = "";

      // Validate basic email format (RFC 5322 simplified)
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        this.frontendErrors.email = "Please enter a valid email address.";
        return false;
      }

      // Check for CRLF sequences (both actual and encoded)
      if (/[\r\n]/.test(email) || /%0d|%0a/i.test(email)) {
        this.frontendErrors.email = "Email address cannot contain line breaks.";
        return false;
      }

      // Check for trailing percent sign
      if (/%$/.test(email)) {
        this.frontendErrors.email = "Email address cannot end with a percent sign.";
        return false;
      }

      return true;
    },
    updateUserInfo() {
      if (!this.validateEmailField()) {
        return;
      }

      this.$inertia.post("/user/api/user-update", this.formUserInfo, {
        preserveScroll: true,
        onSuccess: (e) => {
          if (e.props.flash.message != null)
            this.$store.commit("showFlashMessage", {
              message: e.props.flash.message,
              type: e.props.flash.message_type,
            });
        },
      });
    },
    updateSecurity() {
      if (!this.validPass.value) {
        this.showError = true;
        return;
      }
      this.showError = false;
      this.$inertia.post("/user/api/password-update", this.formSecurity, {
        preserveScroll: true,
        onSuccess: (e) => {
          if (e.props.flash.message != null)
            this.$store.commit("showFlashMessage", {
              message: e.props.flash.message,
              type: e.props.flash.message_type,
            });
        },
      });
    },
    validPassCheck(value) {
      this.validPass = value;
    },
    toggleShowLoading() {
      this.showLoading = !this.showLoading;
    },
    toogleShowDeleteModal() {
      this.errors.user_password = "";
      this.showDeleteModal = !this.showDeleteModal;
    },
    changeActiveMenu(id) {
      if (!this.formUserInfo.email) {
        location.reload();
      }
      this.showLoading = id == 3;
      this.activeMenu = id;
    },
    deleteAccount() {
      const formUser = {
        user_password: this.form.user_password,
      };
      this.$inertia.post("/user/api/user-delete", formUser, {
        preserveScroll: true,
        onSuccess: (e) => {
          if (e.props.flash.message) {
            if (e.props.flash.message_type == "success") {
              this.toogleShowDeleteModal();
              this.$inertia.visit(this.$route("home"));
              this.$store.commit("showFlashMessage", {
                message: e.props.flash.message,
                type: e.props.flash.message_type,
              });
            } else {
              this.$store.commit("showFlashMessage", {
                message: e.props.flash.message,
                type: e.props.flash.message_type,
              });
            }
            this.form.user_password = "";
          }
        },
      });
    },
    getUser() {
      this.showLoading = true;
      this.axios
        .get("/user/api/get-user-name")
        .then((response) => {
          this.formUserInfo.user_name = response.data.name;
          this.formUserInfo.email = this.$page.props.auth.user.email;
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
  },
  mounted() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("tab") === "security") {
      this.activeMenu = 2;
    }
    this.getUser();
  },
};
</script>
